const createTextWithIconTokens = ({ colors, fontSizes, iconSizes }) => ({
  color: colors.neutrals[1],
  fontSize: fontSizes.body[0],
  iconSize: iconSizes.small,
});

export default createTextWithIconTokens;
